/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/promotions",
  shortTitle: "Promotions",
  title: "Discounts and promotions",
  category: "Products and pricing",
  summary: "Rules for genuine promotional prices if they are displayed, without implying a coupon service that is not present.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "Current scope",
      body: [
        "The present checkout has no promotion-code field, loyalty balance, referral credit, subscription discount or automatic bundle pricing. This policy governs only a price reduction or offer visibly attached to an eligible product or collection in the storefront at the time of purchase.",
      ],
    },
    {
      heading: "Clear offer information",
      body: [
        "A promotion should state the eligible item, reduced price or calculation, start or end condition where confirmed, and any stock or per-order limit. An original or comparison price must reflect a genuine basis and must not be invented to make a reduction appear larger. Material exclusions must be shown before checkout rather than hidden after payment.",
      ],
    },
    {
      heading: "Application and conflicts",
      body: [
        "For one checkout attempt, the controlling figure is the total visibly carried from bag to payment hand-off. Two offers combine only when their on-page wording clearly permits it. If software discounts an excluded piece, customer care may hold the unaccepted request and let the buyer choose the correct figure or cancellation. No larger sum may be substituted without the buyer's agreement.",
      ],
    },
    {
      heading: "Returns and legal rights",
      body: [
        "When a reduced-price line qualifies for money back, its refund starts from that line's real checkout charge—not a higher comparison figure. Defects, danger and material mismatch remain assessable even where an offer applied. Before ordering, a shopper may email customer care about offer wording or an accessible way to understand it.",
      ],
    },
  ],
};
